import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
export const FilePreviewModalDraw = observer(_ref => {
  _objectDestructuringEmpty(_ref);
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.drawControllers
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.drawController
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('Draw line'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => store.files.changeDraw('line'),
    className: store.files.drawType === 'line' ? 'active' : ''
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "paint-line"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.drawController
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('Whiteout'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => store.files.changeDraw('erase'),
    className: store.files.drawType === 'erase' ? 'active' : ''
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "erase"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.drawController
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('Draw rectangle'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => store.files.changeDraw('rectangle'),
    className: store.files.drawType === 'rectangle' ? 'active' : ''
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "paint-rectangle"
  })))));
});